import { Button, ButtonSizes, ButtonTypes } from '@leegality/leegality-react-component-library';
import { cn } from '@utils/general';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';

// One selectable rating value (star, NPS number, thumb, emoji) as a library
// borderless secondary button; `selected` / `highlighted` pick up the brand colour.
const RatingOptionButton = ({
  score, label, renderIcon, selected, highlighted, className, onSelect, onHover,
}) => {
  const handleClick = useCallback(() => onSelect(score), [onSelect, score]);
  const handleMouseEnter = useCallback(() => onHover?.(score), [onHover, score]);

  return (
    <div onMouseEnter={handleMouseEnter}>
      <Button
        type={ButtonTypes.SECONDARY}
        borderLess
        size={ButtonSizes.SMALL}
        label={label}
        renderIcon={renderIcon}
        className={cn('feedback-rating-option', { selected, highlighted }, className)}
        onClick={handleClick}
      />
    </div>
  );
};

RatingOptionButton.propTypes = {
  score: PropTypes.number.isRequired,
  label: PropTypes.string,
  renderIcon: PropTypes.func,
  selected: PropTypes.bool,
  highlighted: PropTypes.bool,
  className: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onHover: PropTypes.func,
};

RatingOptionButton.defaultProps = {
  label: undefined,
  renderIcon: undefined,
  selected: false,
  highlighted: false,
  className: '',
  onHover: null,
};

export default memo(RatingOptionButton);
